"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.privateLeasingMandatoryKeys = exports.businessLeasingMandatoryKeys = exports.commonLeasingMandatoryKeys = exports.privateLoanMandatoryKeys = exports.businessLoanMandatoryKeys = exports.businessMandatoryKeys = exports.commonLoanMandatoryKeys = exports.commonMandatoryKeys = void 0;
exports.commonMandatoryKeys = [
    'downPayment',
    'duration',
    'groupCode',
    'ignoreCampaigns',
    'insuranceCompanyNumber',
    'make',
    'model',
    'note',
    'preferEmailOverSms',
    'price',
    'registrationYear',
    'subsidizerId',
    'applicant.contacts.mobilePhone',
    'applicant.contacts.email',
    'salesPerson.id',
];
exports.commonLoanMandatoryKeys = ['manualAdministrationFee'];
exports.businessMandatoryKeys = ['applicant.organizationNumber'];
exports.businessLoanMandatoryKeys = [...exports.commonMandatoryKeys, ...exports.commonLoanMandatoryKeys, ...exports.businessMandatoryKeys];
exports.privateLoanMandatoryKeys = [
    ...exports.commonMandatoryKeys,
    ...exports.commonLoanMandatoryKeys,
    'applicant.ssn',
    'coSigner.ssn',
];
exports.commonLeasingMandatoryKeys = [
    'enovaGrant',
    'pricePerAdditionalMile',
    'registrationFee',
    'residualValue',
    'yearlyMilage',
];
exports.businessLeasingMandatoryKeys = [
    ...exports.commonMandatoryKeys,
    ...exports.commonLeasingMandatoryKeys,
    ...exports.businessMandatoryKeys,
];
exports.privateLeasingMandatoryKeys = [
    ...exports.commonMandatoryKeys,
    ...exports.commonLeasingMandatoryKeys,
    'shouldIncludeFees',
    'applicant.ssn',
];
//# sourceMappingURL=application.js.map